import React from "react";
import { useNavigate } from "react-router-dom";
import { linkOpen } from "utils/util";
import Badge from "components/common/Badge";
import CmsPreviewShell from "./CmsPreviewShell";

const NoticeComponent = ({ title, subtitle, layout, items = [] }) => {
  const navigate = useNavigate();
  const handleClick = (link) => linkOpen(link, navigate);
  
  return (
    <CmsPreviewShell title={title} subtitle={subtitle}>
      <ul className={`cms-notice cms-notice--${layout}`}>
        {items.map((item) => (
          <li key={item.id} className="cms-notice__item" onClick={() => handleClick(item.link)}>
            <div className="cms-notice__main">
              {item.badge &&
              <Badge text={item.badge} type='soft' color='red'></Badge>
              }
              <span className="cms-notice__title">{item.title}</span>
            </div>
            <span className="cms-notice__date">{item.date}</span>
          </li>
        ))}
      </ul>
    </CmsPreviewShell>
  );
};

export default NoticeComponent;
